<template>
  <div class="guide-content">
    <div
      v-for="(item, index) in list"
      :key="index"
      :id="item.id"
      :class="['guide-item', 'level' + item.level]"
    >
      <h2 v-if="item.title">
        <a :id="item.id" href="" class="header-anchor">#</a>{{ item.title }}
      </h2>
      <div class="item-text" v-if="item.content">
        <span> {{ item.content | filterContent }}</span>
        <p
          class="menu-list"
          v-if="item.contentArray && item.contentArray.length"
        >
          <span
            class="menu-wrap"
            v-for="(menu, index) in item.contentArray"
            :key="menu"
          >
            <span class="menu">{{ menu }}</span>
            <span class="menu-icon" v-if="index != item.contentArray.length - 1"
              >></span
            >
          </span>
        </p>
      </div>
      <section
        v-if="item.imgUrlList && item.imgUrlList.length"
        class="img-list"
      >
        <p
          :class="[
            'img-wrap',
            imgObj.display == 'inline' ? 'img-float' : 'img-block',
          ]"
          v-for="(imgObj, index2) in item.imgUrlList"
          :key="index2"
        >
          <span class="img-label" v-if="imgObj.label">{{ imgObj.label }}</span>
          <img :src="imgObj.url" />
        </p>
        <div class="clearfix"></div>
      </section>
      <section
        v-if="item.videoUrlList && item.videoUrlList.length"
        class="img-list"
      >
        <p
          :class="[
            'video-wrap',
            video.display == 'inline' ? 'img-float' : 'img-block',
          ]"
          v-for="(video, index2) in item.videoUrlList"
          :key="index2"
        >
          <ai-t-video :url="video.url"> </ai-t-video>
        </p>
        <!-- <div class="clearfix"></div> -->
      </section>

      <section class="note-section" v-if="item.note">
        <strong class="label">注：</strong>
        <p class=" note" v-if="typeof item.note == 'string'">
          {{ item.note }}
        </p>
        <!-- 数组类型的注释 -->
        <div class="note note-arr" v-if="typeof item.note == 'object'">
          <p class="note-item" v-for="note in item.note" :key="note">
            {{ note }}
          </p>
        </div>
      </section>

      <h2 class="footer" v-if="item.footer">{{ item.footer }}</h2>
      <Guide-content
        v-if="item.children && item.children.length"
        :list="item.children"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import aiTVideo from '@/components/common/Video.vue'

export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'Guide-content',
  components: { aiTVideo },
  props: {
    list: [],
  },
  filters: {
    filterContent(val) {
      let text
      let reg_arr = /\${contentArray}/
      text = val
      if (reg_arr.test(val)) {
        text = text.replace(reg_arr, '')
      }
      return text
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.guide-content {
  width: 100%;
  height: 100%;
  .guide-item {
    width: 100%;
    height: 100%;
    a.header-anchor {
      font-size: 0.85em;
      float: left;
      margin-left: -0.87em;
      padding-right: 0.23em;
      margin-top: 0.125em;
      opacity: 0;
    }
    &:not(.custom) > h1,
    &:not(.custom) > h2,
    &:not(.custom) > h3,
    &:not(.custom) > h4,
    &:not(.custom) > h5,
    &:not(.custom) > h6 {
      // margin-top: -3.1rem;
      padding-top: 4.6rem;
      margin-bottom: 2rem;
    }

    .item-text {
      padding: 20px 0;
      .menu-list {
        margin: 10px 0;
        .menu-wrap {
          .menu {
            margin: 0 10px;
          }
        }
      }
    }
    .note-section {
      .label {
        color: #777;
      }
      .note {
        margin-bottom: 10px;
        // opacity: 0.7;
        color: #777;
        font-size: 13px;
        .note-item {
          padding-top: 10px;
        }
      }
    }

    .img-list {
      .img-wrap {
        display: block;
        img {
          height: 100%;
          max-height: 450px;
          width: auto;
        }
        .img-label {
          display: block;
          margin: 15px 0 10px 0;
        }
        &.img-float {
          float: left;
          max-width: 48%;
          margin: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
